import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { Typography } from 'antd';
import {
  ProjectConstructorNavigationControls,
  ProjectsConstructorLayout,
  useNavigateConstructorTabs,
  validateEmployeesTab,
} from '@/views';
import { ErrorCard } from '@/components';
import { ProjectsAddEmployeeForm, EmployeeCardsList } from '@/views';
import { ProjectDto } from '@/core';
import classes from './ProjectsEmployeesPage.module.scss';

export const ProjectsEmployeesPage = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const projectData = useOutletContext<ProjectDto>();
  const { navigateToNextTab, navigateToPreviousTab } = useNavigateConstructorTabs(projectData);
  const isEmployeesTabValid = validateEmployeesTab(projectData);
  const [isErrorNotification, setIsErrorNotification] = useState(false);

  useEffect(() => {
    isEmployeesTabValid && setIsErrorNotification(false);
  }, [isEmployeesTabValid]);

  const navigateToEpicsTab = async () => {
    if (!isEmployeesTabValid) {
      setIsErrorNotification(true);
      return;
    }
    navigateToNextTab();
  };

  return (
    <ProjectsConstructorLayout
      projectData={projectData}
      content={
        <>
          <Typography.Title level={3}>
            {projectData?.name}: {t('addEmployees.title')}
          </Typography.Title>
          <Typography.Text type="secondary" className={classes.pageDescription}>
            {t('addEmployees.description')}
          </Typography.Text>
          <ProjectsAddEmployeeForm projectData={projectData} />
          {(projectData.isCompleted && !isEmployeesTabValid) || isErrorNotification ? (
            <ErrorCard text={t('addEmployees.invalidPage')} />
          ) : null}
          {projectData?.employees.length ? <EmployeeCardsList projectData={projectData} /> : null}
        </>
      }
      navigationControls={
        <ProjectConstructorNavigationControls
          navigateToPreviousTab={navigateToPreviousTab}
          navigateToNextTab={navigateToEpicsTab}
        />
      }
    />
  );
};
